import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const NecromancySvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 32 32">
      <path
        fill={fillColor}
        d="M26.306 24.401c-3.076 0-5.143-1.672-5.143-4.162a4.871 4.871 0 011.06-3.03 2.93 2.93 0 00.691-2.024c0-3.876-5.542-4.715-6.914-4.715s-6.914.84-6.914 4.715a2.93 2.93 0 00.691 2.024 4.871 4.871 0 011.06 3.03c0 2.49-2.066 4.162-5.142 4.162A4.838 4.838 0 011 19.503v-.06a1.65 1.65 0 012.973-.933.326.326 0 01.037.342 1.428 1.428 0 00-.138.651c0 .541.432 2.027 1.823 2.027.682 0 2.27-.126 2.27-1.291a2.077 2.077 0 00-.544-1.388 5.737 5.737 0 01-1.207-3.666C6.214 9.453 12.807 7.6 16 7.6s9.786 1.854 9.786 7.586a5.737 5.737 0 01-1.207 3.666 2.077 2.077 0 00-.544 1.388c0 1.165 1.588 1.29 2.27 1.29 1.391 0 1.823-1.485 1.823-2.026a1.428 1.428 0 00-.138-.651.326.326 0 01.037-.342 1.65 1.65 0 012.973.933v.06a4.838 4.838 0 01-4.694 4.898z"
      />
    </BaseSvg>
  );
};

export default NecromancySvg;
